document.querySelectorAll('.qa_contents_wrap .accordion-header').forEach(header => {
    header.addEventListener('click', () => {
                
                const content = header.nextElementSibling;
                const isVisible = window.getComputedStyle(content).display !== 'none';
                if (isVisible) {
                    content.style.display = 'none';
                } else {
                    content.style.display = 'block';
                }
            });
        });

window.addEventListener("load", function () {
  const bottomFixedItem = document.querySelector(".bottom_fixed_item");
  const aboutSection = document.getElementById("banner");

  if (!aboutSection) {
    console.error("#about セクションが見つかりません。HTML を確認してください。");
    return;
  }

  if (!bottomFixedItem) {
    console.warn(".bottom_fixed_item が見つかりませんが、処理を続行します。");
  }

  function updateVisibility() {
    const aboutTop = aboutSection.getBoundingClientRect().top; // #about の上端の位置
    if (aboutTop <= 0) {
      bottomFixedItem?.classList.add("show"); // #about の上端が画面の上に到達したら `show` を追加
    } else {
      bottomFixedItem?.classList.remove("show"); // #about が画面下に戻ったら `show` を削除
    }
  }

  window.addEventListener("scroll", updateVisibility);
  updateVisibility(); // 初回実行

  var pathName = window.location.pathname;
  var englishElements = document.querySelectorAll('.english');
  var japaneseElements = document.querySelectorAll('.japanese');
  var bn_englishElements = document.querySelectorAll('.banner_english');
  var bn_japaneseElements = document.querySelectorAll('.banner_japanese');

  if (pathName.indexOf("/en") > -1) {
    englishElements.forEach(function(element) {
      element.classList.add('lang_active');
    });
    bn_englishElements.forEach(function(element) {
      element.classList.remove('hidden'); // 表示
    });
    japaneseElements.forEach(function(element) {
      element.classList.remove('lang_active');
    });
    bn_japaneseElements.forEach(function(element) {
      element.classList.add('hidden'); // 非表示
    });
  } else {
    japaneseElements.forEach(function(element) {
      element.classList.add('lang_active');
    });
    bn_japaneseElements.forEach(function(element) {
      element.classList.remove('hidden'); // 表示
    });
    englishElements.forEach(function(element) {
      element.classList.remove('lang_active');
    });
    bn_englishElements.forEach(function(element) {
      element.classList.add('hidden'); // 非表示
    });
  }
  
});


// メニュー展開時に背景を固定
let scrollPosition = 0;

const backgroundFix = (bool) => {
  const scrollingElement = () => {
    const browser = window.navigator.userAgent.toLowerCase();
    if ("scrollingElement" in document) return document.scrollingElement;
    return document.documentElement;
  };

  if (bool) {
    scrollPosition = scrollingElement().scrollTop;
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.left = "0";
    document.body.style.width = "100%";
    document.body.style.height = "100vh";
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.width = "";
    document.body.style.height = "";
    document.body.style.overflow = "";
    window.scrollTo(0, scrollPosition);
  }
};


// 変数定義
const CLASS = "-active";
let flg = false;
let accordionFlg = false;

let hamburger = document.getElementById("js-hamburger");
let focusTrap = document.getElementById("js-focus-trap");
let menu = document.querySelector(".js-nav-area");
let accordionTrigger = document.querySelectorAll(".js-sp-accordion-trigger");
let accordion = document.querySelectorAll(".js-sp-accordion");
let menuLinks = menu.querySelectorAll(".global-navigation__link"); // メニュー内のリンクを取得

// メニュー開閉制御
hamburger.addEventListener("click", (e) => {
  e.currentTarget.classList.toggle(CLASS);
  menu.classList.toggle(CLASS);
  if (flg) {
    backgroundFix(false);
    hamburger.setAttribute("aria-expanded", "false");
    hamburger.focus();
    flg = false;
  } else {
    backgroundFix(true);
    hamburger.setAttribute("aria-expanded", "true");
    flg = true;
  }
});

window.addEventListener("keydown", (event) => { // イベント引数を追加
  if (event.key === "Escape") {
    hamburger.classList.remove(CLASS);
    menu.classList.remove(CLASS);

    backgroundFix(false);
    hamburger.focus();
    hamburger.setAttribute("aria-expanded", "false");
    flg = false;
  }
});

window.addEventListener('DOMContentLoaded', function() {

const menuLinks = document.querySelectorAll(".global-navigation__link");
menuLinks.forEach((link) => {
  link.addEventListener("click", (e) => {
    const targetId = link.getAttribute("href");
    const targetElement = document.getElementById(targetId.slice(1));

    if (targetElement) {
      e.preventDefault();

      // 少し遅延させてスクロール処理を実行
      setTimeout(() => {
        if (hamburger) {
          backgroundFix(false);
        }
        window.scrollTo({
          top: 0
        });
      }, 0);

      // 少し遅延させてスクロール処理を実行
      setTimeout(() => {
        
      // スクロール位置の計算方法を改良
      const targetRect = targetElement.getBoundingClientRect();
      const targetPosition = targetRect.top + window.scrollY - 16;

      if (hamburger) {
        backgroundFix(false);
        hamburger.classList.remove(CLASS);
        menu.classList.remove(CLASS);
      }
        
        window.scrollTo({
          top: targetPosition,
          behavior: "smooth"
        });
      }, 1); // 50ms の遅延

      if (hamburger) {
        hamburger.setAttribute("aria-expanded", "false");
        flg = false;
      }
    }
  });
});

// 背景画像の設定
const backgroundImage = document.querySelector('.btown_header_wrap');
//backgroundImage.style.backgroundImage = 'linear-gradient(to right, #004d40, #757575, #ff5722)';
  
  // アニメーションのタイミングを設定
  setTimeout(() => {
    // 背景のアニメーション
    backgroundImage.classList.add('active');

    // テキストコンテナのアニメーション (300msで開始)
    setTimeout(() => {
      document.querySelector('.main_message').classList.add('active');

      // 各テキスト行を段階的に表示（100msずつ遅延）
      const textLines = document.querySelectorAll('.main_message p');

      // BRAVE表示 (テキストコンテナアニメーション開始から150ms後)
      setTimeout(() => {
        textLines[0].style.opacity = '1';
        textLines[0].style.transform = 'translateY(0)';

        // MASSIVE表示 (BRAVE開始から100ms後)
        setTimeout(() => {
          textLines[1].style.opacity = '1';
          textLines[1].style.transform = 'translateY(0)';

          // SURVIVE表示 (MASSIVE開始から100ms後)
          setTimeout(() => {
            textLines[2].style.opacity = '1';
            textLines[2].style.transform = 'translateY(0)';

            // GROOVE表示 (SURVIVE開始から100ms後)
            setTimeout(() => {
              textLines[3].style.opacity = '1';
              textLines[3].style.transform = 'translateY(0)';

              // 黒いボックスの表示 (GROOVE開始から50ms後)
              setTimeout(() => {
                document.querySelector('.black_box').classList.add('active');

                // メニューの表示 (黒いボックス開始から200ms後)
                setTimeout(() => {
                  document.querySelector('.nav_pc').classList.add('active');

                  // メニュー項目を順番に表示
                  const menuItems = document.querySelectorAll('.nav_pc li a');
                  menuItems.forEach((item, index) => {
                    setTimeout(() => {
                      item.style.opacity = '1';
                      item.style.transform = 'translateY(0)';
                    }, 100 * index);
                  });

                  // バナーの表示 (メニュー表示開始から300ms後)
                  setTimeout(() => {
                    document.querySelector('.btwon_whats_wrap').classList.add('active');

                    // バナーテキストのアニメーション (バナー表示開始から100ms後)
                    setTimeout(() => {
                      document.querySelector('.banner-text').style.opacity = '1';
                      document.querySelector('.banner-text').style.transform = 'translateY(0)';
                    }, 100);
                  }, 50);
                }, 50);
              }, 50);
            }, 100);
          }, 100);
        }, 100);
      }, 150);
    }, 300);
  }, 100);

  const scrollUpElements = document.querySelectorAll(".scroll_up");

  const scrollAnimation = () => {
    const triggerMargin = 100; // この値を調整して発火タイミングを変更
    const windowHeight = window.innerHeight;

    scrollUpElements.forEach(element => {
      const elementTop = element.getBoundingClientRect().top;

      if (elementTop < windowHeight - triggerMargin) {
        element.classList.add("show");
      }
    });
  };

  window.addEventListener("scroll", scrollAnimation);
  scrollAnimation(); // 初期ロード時に実行


});

// メニュー内アコーディオン制御
accordionTrigger.forEach((item) => {
  item.addEventListener("click", (e) => {
    e.currentTarget.classList.toggle(CLASS);
    e.currentTarget.nextElementSibling.classList.toggle(CLASS);
    if (accordionFlg) {
      e.currentTarget.setAttribute("aria-expanded", "false");
      accordionFlg = false;
    } else {
      e.currentTarget.setAttribute("aria-expanded", "true");
      accordionFlg = true;
    }
  });
});

// フォーカストラップ制御
focusTrap.addEventListener("focus", () => {
  hamburger.focus();
});
